import { CssBaseline, ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { esES } from '@mui/x-date-pickers/locales'
import { FC, ReactNode, useEffect } from 'react'

import useSettings from '../../../hooks/useSettings'

type MatxThemeProps = {
  children: ReactNode | ReactNode[]
}

/**
 * Inicio y creación de la plantilla matx
 * @author isi-template
 * @param children
 * @constructor
 */
const MatxTheme: FC<MatxThemeProps> = ({ children }: MatxThemeProps) => {
  const { settings } = useSettings()
  const activeTheme = { ...settings.themes[settings.activeTheme] }

  // Sincronizamos el modo del tema con el DOM global para librerías externas (como SweetAlert2)
  useEffect(() => {
    // Extraemos 'light' o 'dark' del objeto theme de Material-UI
    const currentMode = activeTheme.palette?.mode || 'light'
    document.body.setAttribute('data-theme', currentMode)
  }, [activeTheme.palette?.mode])

  return (
    <ThemeProvider theme={activeTheme}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale="es"
        localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <CssBaseline />
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  )
}

export default MatxTheme
